<template>
  <div class="el-col-24">
    <h5 class="warp-title">快捷语分类管理</h5>
    <div class="fast-warp">
      <el-button v-if="querybtn.shortcut_type_management_addUp === 1" class="md_20" size="mini" type="primary" @click="firstAdd">添加一级</el-button>
      <el-tree
        :data="dataList"
        :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <el-input size="mini" class="w200" v-model="data.label" placeholder="" maxlength="50"></el-input>
          <span class="text-style">
            <el-button
              v-if="data.flag===1 && querybtn.shortcut_type_management_addDown === 1"
              type="text"
              size="mini"
              @click="() => append(node, data)">
              添加
            </el-button>
            <el-button
              type="text"
              size="mini"
              @click="() => remove(node, data)">
              删除
            </el-button>
          </span>
        </span>
      </el-tree>
      <el-button  v-if="querybtn.shortcut_type_management_summit === 1" class="mt_20" type="primary" @click="submitForm()" :loading="isSubmitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import {sysDictionary, addSysDictionary, delShortcutLanguageType} from '../../api/fast/index'
import { queryButtonPermission } from '../../api/public/auth'
export default {
  name: 'FastType',
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
    let data = {
      id: global.$sider
    }
    queryButtonPermission(data).then((info) => {
      if (info.data.resultCode === 0) {
        this.querybtn = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
  },
  components: {
  },
  data () {
    return {
      isSubmitLoading: false,
      querybtn: {},
      dataList: []
    }
  },
  methods: {
    initData () {
      sysDictionary().then(info => {
        if (info.data.resultCode === 0) {
          this.dataList = info.data.resultData
        } else {
          this.$message.error(info.data.resultMessage)
        }
      })
    },
    firstAdd () {
      this.dataList.push({
        id: '',
        label: '',
        flag: 1
      })
      setTimeout(() => {
        let element = $('.el-tree .el-tree-node').last()[0]
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }, 10)
    },
    // 滚动到添加的数据
    scrollToAddOne () {
      setTimeout(() => {
        let element = $('.is-current .el-tree-node__children .custom-tree-node').last()[0]
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }, 10)
    },
    append (node, data) {
      node.expanded = true
      const newChild = { id: '', label: '', flag: 2, children: [] }
      if (!data.children) {
        this.$set(data, 'children', [])
      }
      data.children.push(newChild)
      this.scrollToAddOne()
    },
    remove (node, data) {
      this.$confirm('是否删除这一分类', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        if (data.id) {
          let datas = {
            id: data.id
          }
          delShortcutLanguageType(datas).then(info => {
            if (info.data.resultCode === 0) {
              const parent = node.parent
              const children = parent.data.children || parent.data
              const index = children.findIndex(d => d.id === data.id)
              children.splice(index, 1)
            } else {
              this.$message.error(info.data.resultMessage)
            }
          })
        } else {
          const parent = node.parent
          const children = parent.data.children || parent.data
          const index = children.findIndex(d => d.id === data.id)
          children.splice(index, 1)
        }
      })
    },
    submitForm () {
      let data = {
        jsonObject: JSON.stringify(this.dataList)
      }
      this.isSubmitLoading = true
      addSysDictionary(data).then(info => {
        this.isSubmitLoading = false
        if (info.data.resultCode === 0) {
          this.initData()
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isSubmitLoading = false
      })
    }
  },
  mounted () {
    this.initData()
  }
}
</script>
<style lang="less" scoped>
// /deep/.el-tree-node__content{
//   margin-bottom: 15px;
// }
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  /deep/.el-input__inner{
    font-size: 16px;
    height: 32px;
  }
}
/deep/.el-tree-node__content{
  height: 36px;
}
/deep/.el-tree-node__expand-icon{
  font-size: 20px;
}
.text-style .el-button{
  font-size: 16px;
}
.w200{
  width: 200px;
}
.md_20 {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Fast/FastType.vue